interface AccordionProps {
  title: React.ReactNode;
  children: React.ReactNode;
  isOpen: boolean;
  onToggle: () => void;
}

export const TailwindAccordion = ({
  title,
  children,
  isOpen,
  onToggle,
}: AccordionProps) => {
  return (
    <div className="border  mt-2">
      <button className="w-full flex justify-between items-center text-left  text-gray-800 bg-gray-100 ">
        <span
          className="w-[40px] text-center text-lg hover:text-gray-500"
          onClick={onToggle}
        >
          {isOpen ? "−" : "+"}{" "}
        </span>
        <span className="w-full">{title}</span>
      </button>
      {isOpen && (
        <div className="px-4 py-2 text-sm text-gray-700 bg-white border-t">
          {children}
        </div>
      )}
    </div>
  );
};
